
<div :class="['sales-stats', { page }]">
  <stat-item
    label="Rate of Growth"
    :value="`${timelineData.timelineRoi > 0 ? '+' : ''}${$filters.percentage(timelineData.timelineRoi, { allowZero: false })}`"
    :success="timelineData.timelineRoi > 0"
    :error="timelineData.timelineRoi < 0"
  />

  <stat-item
    label="Real Dollar Change"
    :value="`${timelineData.timelineDollarChange > 0 ? '+' : ''}${$filters.currency(timelineData.timelineDollarChange, { allowZero: false })}`"
    :success="timelineData.timelineDollarChange > 0"
    :error="timelineData.timelineDollarChange < 0"
  />

  <stat-item
    label="Starting Price"
    :value="$filters.currency(timelineData.timelineStartPrice, { allowZero: false })"
  />

  <stat-item
    label="Current Price"
    :value="$filters.currency(timelineData.timelineCurrentPrice, { allowZero: false })"
  />

  <stat-item
    label="Number of Sales"
    :value="$filters.number(timelineData.timelineNumSales, { allowZero: false })"
  />

  <stat-item
    label="Average Price"
    :value="$filters.currency(timelineData.timelineAveragePrice, { allowZero: false })"
  />

  <stat-item
    label="Low Price"
    :value="$filters.currency(timelineData.timelineLowPrice, { allowZero: false })"
  />

  <stat-item
    label="High Price"
    :value="$filters.currency(timelineData.timelineHighPrice, { allowZero: false })"
  />
</div>
